module.exports = require('./Loading.vue');